import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Importer les fichiers de traduction
import en from "./locales/en.json";
import fr from "./locales/fr.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    fr: {
      translation: fr,
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  // Envoyer la langue au backend via un cookie
  document.cookie = `i18next=${lng}; path=/`;
});

export default i18n;
